import { useSelector } from 'react-redux';
import { RootState } from '../redux/types';
import { useUnreleasedFeatures } from './useUnreleasedFeatures';

export const usePoAutomationFeature = () => {
    // Read from authorizedResellers, which is fetched on every load; selectedReseller is restored from localStorage and can be stale.
    const isResellerEnabled = useSelector((state: RootState) => {
        const { selectedReseller, authorizedResellers } = state.resellerReducer;
        const resellerId = selectedReseller.value?.resellerId;
        return (
            authorizedResellers.value?.find((reseller) => reseller.resellerId === resellerId)?.poAutomationEnabled ===
            true
        );
    });
    const isResellerLoaded = useSelector((state: RootState) => {
        const { selectedReseller, authorizedResellers } = state.resellerReducer;
        return (
            !selectedReseller.value ||
            authorizedResellers.status === 'Loaded' ||
            authorizedResellers.status === 'Failed'
        );
    });
    // The stage load never reaches 'Loaded'; it settles with either a value or an error.
    const isStageLoaded = useSelector((state: RootState) => {
        const { stage } = state.systemReducer;
        return stage.value !== undefined || stage.error !== undefined;
    });
    // TODO: Remove the internal-only restriction at launch: https://sim.amazon.com/issues/DFT-2117
    const { isUnreleasedFeaturesEnabled } = useUnreleasedFeatures();

    return {
        isPoAutomationEnabled: isResellerEnabled && isUnreleasedFeaturesEnabled,
        isPoAutomationFeatureLoaded: isResellerLoaded && isStageLoaded,
    };
};
